<template>
    <section
        id="cta"
        dir="rtl"
        class="relative px-5 sm:px-8 py-20 md:py-24 overflow-hidden bg-[#F8FAFC]"
    >
        <div class="pointer-events-none absolute inset-0 overflow-hidden">
            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full bg-[rgba(230,57,70,0.1)] blur-[120px]" />
            <div class="absolute top-[15%] right-[12%] w-[320px] h-[320px] rounded-full bg-[rgba(242,107,90,0.15)] blur-[110px]" />
            <div class="absolute bottom-[10%] left-[10%] w-[300px] h-[300px] rounded-full bg-[rgba(242,107,90,0.1)] blur-[110px]" />
            <div
                class="absolute inset-0 opacity-[0.12]"
                :style="{
                    backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)',
                    backgroundSize: '32px 32px',
                }"
            />
            <span class="absolute top-10 right-[8%] font-mono text-6xl md:text-7xl font-extrabold text-[rgba(230,57,70,0.06)] select-none">&lt;/&gt;</span>
            <span class="absolute top-[30%] left-[7%] font-mono text-5xl md:text-6xl font-extrabold text-[rgba(242,107,90,0.07)] select-none">AI</span>
            <span class="absolute bottom-14 right-[14%] font-mono text-4xl md:text-5xl font-extrabold text-[rgba(34,197,94,0.06)] select-none">JS</span>
            <span class="absolute bottom-8 left-[16%] font-mono text-3xl md:text-4xl font-extrabold text-[rgba(230,57,70,0.06)] tracking-widest select-none">0101</span>
        </div>

        <div class="relative mx-auto max-w-5xl">
            <div class="relative bg-white rounded-[2.5rem] px-6 sm:px-16 py-10 sm:py-14 border border-white shadow-[0_24px_56px_-20px_rgba(15,23,42,0.12)] overflow-hidden">
                <div
                    class="pointer-events-none absolute inset-0 rounded-[2.5rem] opacity-30"
                    :style="{
                        padding: '1px',
                        background: 'linear-gradient(to bottom left, #3b82f6, #22d3ee)',
                        WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'xor',
                        maskComposite: 'exclude',
                    }"
                />

                <div class="relative flex flex-col items-center text-center space-y-6">
                    <div class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[rgba(230,57,70,0.08)] text-[#E63946] border border-[rgba(230,57,70,0.15)] text-xs sm:text-sm font-bold">
                        <span class="relative flex h-2 w-2">
                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F26B5A] opacity-75" />
                            <span class="relative inline-flex rounded-full h-2 w-2 bg-[#E63946]" />
                        </span>
                        التحديث الجديد لسنة 2026 متاح دلوقتي
                    </div>

                    <h2 class="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.2]" :style="{ color: '#1A0E10' }">
                        بلاش رعب الامتحان…
                        <span
                            class="bg-clip-text text-transparent"
                            :style="{ backgroundImage: 'linear-gradient(to left, #E63946, #F26B5A)' }"
                        >
                            اتعلم البرمجة صح
                        </span>
                        مع غنيم
                    </h2>

                    <p class="max-w-2xl text-sm sm:text-base leading-relaxed" :style="{ color: 'rgba(11,18,32,0.7)' }">
                        منهج <span class="font-bold" :style="{ color: '#1A0E10' }">Programming &amp; AI</span> كامل بطريقة سهلة وعملية —
                        شرح، تدريب، مراجعات، وامتحانات تخليك تدخل يوم الامتحان <span class="font-bold" :style="{ color: '#1A0E10' }">واثق 100%</span>.
                    </p>

                    <div class="px-6 sm:px-8 py-2.5 sm:py-3 rounded-full bg-gradient-to-l from-[rgba(230,57,70,0.1)] to-[rgba(242,107,90,0.1)] text-[#E63946] text-base sm:text-xl lg:text-2xl font-extrabold font-mono border border-[rgba(230,57,70,0.2)]">
                        #البرمجة_مع_غنيم
                    </div>

                    <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full justify-center pt-1">
                        <router-link
                            :to="{ name: 'register' }"
                            class="group inline-flex items-center justify-center gap-3 px-9 sm:px-10 py-4 rounded-2xl text-base sm:text-lg font-extrabold text-white shadow-[0_18px_38px_-10px_rgba(37,99,235,0.55)] hover:-translate-y-1 hover:shadow-[0_24px_50px_-10px_rgba(37,99,235,0.7)] transition-all"
                            :style="{ background: 'linear-gradient(to left, #E63946, #F26B5A)' }"
                        >
                            ابدأ الآن
                            <lucide-icon name="ArrowLeft" class="h-5 w-5 transition-transform group-hover:-translate-x-1.5" />
                        </router-link>
                        <a
                            :href="WHATSAPP_URL"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="inline-flex items-center justify-center gap-2 px-7 sm:px-8 py-4 rounded-2xl text-sm sm:text-base font-bold text-[rgba(26,14,16,0.8)] bg-white border border-slate-200 hover:border-emerald-300 hover:text-emerald-600 hover:bg-[rgba(236,253,245,0.5)] transition-all"
                        >
                            <lucide-icon name="MessageCircle" class="h-5 w-5 text-emerald-500" />
                            تواصل واتساب
                        </a>
                    </div>

                    <p class="text-xs sm:text-sm pt-1" :style="{ color: 'rgba(11,18,32,0.5)' }">
                        مناسب لطلاب أولى وتانية ثانوي — المنهج أولًا… والمهارة خطوة بخطوة.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LucideIcon from './LucideIcon.vue';
import { WHATSAPP_URL } from './landing-data';

export default {
    name: 'WelcomeFinalCTA',
    components: { LucideIcon },
    data() {
        return {
            WHATSAPP_URL,
        };
    },
};
</script>
